<template>
  <div>
    <button>公共组件-按钮</button>
  </div>
</template>

<script>
export default {
  // 组件的名字很重要
  name: 'MyButton',
  data () {
    return { }
  }
}
</script>
